// https://splidejs.com/guides/getting-started/
import Splide from '@splidejs/splide';

function handleKeys(e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    const openModal = document.querySelector('.modal.is-open');
    // eslint-disable-next-line
    toggleModal(openModal.id);
  }
}

function toggleModal() {
  const carouselModal = document.querySelector('.carousel.modal');
  const modalCloseButton = document.querySelector('button.modal--close');
  if (!carouselModal) return;
  if (carouselModal.classList.contains('is-open')) {
    window.removeEventListener('keyup', handleKeys);
    carouselModal.classList.remove('is-open');
    return;
  }
  window.addEventListener('keyup', handleKeys);
  modalCloseButton.focus();
  carouselModal.classList.add('is-open');
}
function setUpModal() {
  const modalClose = document.querySelectorAll('.modal--close');
  modalClose.forEach((close) => {
    close.addEventListener('click', toggleModal);
  });
}

function setUpAdvancedSplide() {
  const thumbnailCarousel = document.querySelector('.carousel--advanced .thumbnails');
  if (!thumbnailCarousel) return null;
  // Advanced slider
  const smallSplide = new Splide(thumbnailCarousel, {
    autoWidth: true,
    gap: '1rem',
    isNavigation: true,
    pagination: false,
  });

  const splide = new Splide('#main-carousel', {
    pagination: false,
    type: 'loop',
  });

  const thumbnails = document.querySelectorAll('.thumbnail');
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      splide.go(index);
    });
  });

  splide.on('mounted move', () => {
    smallSplide.go(splide.index);
  });
  smallSplide.mount();
  return splide.mount();
}

function setUpClassicSplide() {
  setUpModal();
  const carousel = document.querySelector('.carousel--classic .splide');
  if (!carousel) return null;
  // classic slider
  new Splide(carousel, {
    type: 'slide',
    perPage: 2,
    autoWidth: true,
    gap: '1rem',
    isNavigation: true,
    pagination: false,
  }).mount();

  const splide = new Splide('#modal-carousel', {
    pagination: false,
    type: 'loop',
  });

  const thumbnails = document.querySelectorAll('.thumbnail');
  let current;

  function initThumbnail(thumbnail, index) {
    thumbnail.addEventListener('click', () => {
      toggleModal();
      splide.go(index);
    });
  }

  thumbnails.forEach((thumbnail, index) => initThumbnail(thumbnail, index));
  splide.on('mounted move', () => {
    const thumbnail = thumbnails[splide.index];
    if (thumbnail) {
      if (current) {
        current.classList.remove('is-active');
      }
      thumbnail.classList.add('is-active');
      current = thumbnail;
    }
  });
  return splide.mount();
}

(function (Drupal, once) {
  Drupal.behaviors.carousel = {
    attach(context) {
      const advancedElements = once('init', '.carousel--advanced', context);
      advancedElements.forEach(setUpAdvancedSplide);

      const classicElements = once('init', '.carousel--classic', context);
      classicElements.forEach(setUpClassicSplide);
    }
  };
}(Drupal, once));
